export interface VideoItem {
  id: string;
  title: string;
  description: string;
  coverImage: string;
  category: string;
  duration: string;
  views: number;
  rating: number;
  publishDate: string;
  tags: string[];
  slug: string;
}

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '2024年度最受欢迎华语电影合集',
    description: '精心挑选的年度最佳华语电影，涵盖动作、爱情、喜剧等多种类型，每一部都是口碑佳作，让您一次看过瘾。',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20cinematic%20movie%20poster%20composition%20with%20warm%20golden%20lighting%2C%20abstract%20film%20reel%20texture%2C%20elegant%20Chinese%20calligraphy%20style%2C%20soft%20gradient%20background%20in%20warm%20amber%20tones%2C%20professional%20movie%20poster%20design%20aesthetic&width=800&height=450&seq=video-cover-001&orientation=landscape',
    category: 'dianshiju',
    duration: '2:15:30',
    views: 1520000,
    rating: 9.2,
    publishDate: '2024-12-15',
    tags: ['电影', '华语', '热门', '高分'],
    slug: '2024-best-chinese-movies',
  },
  {
    id: 'v002',
    title: '爆笑综艺合集：让你笑到停不下来',
    description: '汇集全网最搞笑的综艺片段，涵盖脱口秀、真人秀、游戏竞技等多种类型，陪伴你度过欢乐时光。',
    coverImage: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20lighting%20effects%2C%20dynamic%20atmosphere%2C%20warm%20spotlight%2C%20entertainment%20studio%20background%20with%20abstract%20geometric%20patterns%2C%20joyful%20and%20energetic%20mood&width=800&height=450&seq=video-cover-002&orientation=landscape',
    category: 'zongyi',
    duration: '1:08:45',
    views: 2380000,
    rating: 9.5,
    publishDate: '2025-01-08',
    tags: ['综艺', '搞笑', '娱乐', '热门'],
    slug: 'funny-variety-show-compilation',
  },
  {
    id: 'v003',
    title: '精选创意短视频：每日新鲜看不停',
    description: '来自全网创作者的精彩短视频作品，包含生活妙招、美食制作、旅行记录、萌宠日常等丰富内容。',
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20short%20video%20collage%20with%20warm%20earthy%20tones%2C%20smartphone%20screen%20displaying%20various%20content%20thumbnails%2C%20modern%20social%20media%20aesthetic%2C%20cozy%20ambient%20lighting%2C%20minimalist%20composition%20with%20soft%20shadows&width=800&height=450&seq=video-cover-003&orientation=landscape',
    category: 'duanshipin',
    duration: '0:45:20',
    views: 3210000,
    rating: 9.1,
    publishDate: '2025-02-20',
    tags: ['短视频', '创意', '生活', '热门'],
    slug: 'creative-short-videos-daily',
  },
  {
    id: 'v004',
    title: '经典动漫剧场版合集：回忆与感动',
    description: '精选经典动漫剧场版作品，从热血少年到治愈日常，每一部都是动漫迷不可错过的经典之作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20with%20warm%20sunset%20sky%2C%20beautiful%20character%20silhouettes%2C%20dreamy%20atmosphere%2C%20soft%20golden%20clouds%2C%20emotional%20and%20nostalgic%20vibe%2C%20flat%20color%20design%20with%20gentle%20textures&width=800&height=450&seq=video-cover-004&orientation=landscape',
    category: 'dongman',
    duration: '1:55:00',
    views: 1870000,
    rating: 9.4,
    publishDate: '2025-01-25',
    tags: ['动漫', '剧场版', '经典', '高分'],
    slug: 'classic-anime-movies-collection',
  },
  {
    id: 'v005',
    title: '地球脉动：自然纪录片的震撼之美',
    description: '高清纪录片带你领略地球最美的自然风光，从极地冰川到热带雨林，感受大自然的神奇与壮丽。',
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20landscape%20with%20warm%20golden%20hour%20sunlight%2C%20mountain%20range%20reflected%20in%20crystal%20lake%2C%20documentary%20cinematography%20style%2C%20rich%20earthy%20tones%20of%20forest%20green%20and%20amber%2C%20breathtaking%20scenic%20view&width=800&height=450&seq=video-cover-005&orientation=landscape',
    category: 'jilupian',
    duration: '1:30:00',
    views: 980000,
    rating: 9.6,
    publishDate: '2025-03-01',
    tags: ['纪录片', '自然', '高清', '震撼'],
    slug: 'planet-earth-nature-documentary',
  },
  {
    id: 'v006',
    title: 'NBA精彩赛事回放：巅峰对决时刻',
    description: '精选本赛季最精彩的NBA比赛回放，包含绝杀瞬间、巨星对决、经典逆转等令人热血沸腾的比赛。',
    coverImage: 'https://readdy.ai/api/search-image?query=Basketball%20arena%20with%20dramatic%20lighting%2C%20warm%20court%20spotlights%2C%20dynamic%20sports%20action%20moment%2C%20energetic%20stadium%20atmosphere%2C%20professional%20sports%20photography%20style%2C%20rich%20amber%20and%20orange%20accents&width=800&height=450&seq=video-cover-006&orientation=landscape',
    category: 'tiyu',
    duration: '2:30:00',
    views: 2100000,
    rating: 9.3,
    publishDate: '2025-02-15',
    tags: ['NBA', '篮球', '赛事', '精彩'],
    slug: 'nba-highlights-replay',
  },
  {
    id: 'v007',
    title: '2025年度华语乐坛热门MV大赏',
    description: '汇集年度最受欢迎的华语音乐MV，流行、摇滚、民谣、说唱等多种风格，视听双重享受。',
    coverImage: 'https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20warm%20dramatic%20lighting%2C%20abstract%20sound%20wave%20visualization%2C%20elegant%20golden%20and%20amber%20color%20palette%2C%20modern%20music%20production%20aesthetic%2C%20soft%20bokeh%20effects%2C%20festive%20atmosphere&width=800&height=450&seq=video-cover-007&orientation=landscape',
    category: 'yinyue',
    duration: '1:20:00',
    views: 1750000,
    rating: 9.0,
    publishDate: '2025-01-30',
    tags: ['音乐', 'MV', '华语', '热门'],
    slug: '2025-chinese-music-mv-awards',
  },
  {
    id: 'v008',
    title: '零基础学编程：Python入门到精通',
    description: '从零开始学习Python编程，课程内容涵盖基础语法、数据处理、Web开发等，适合完全没有编程基础的初学者。',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20coding%20workspace%20with%20warm%20ambient%20light%2C%20laptop%20displaying%20code%20editor%2C%20minimalist%20desk%20setup%2C%20cozy%20learning%20environment%2C%20soft%20golden%20and%20cream%20color%20scheme%2C%20educational%20atmosphere&width=800&height=450&seq=video-cover-008&orientation=landscape',
    category: 'jiaoyu',
    duration: '5:30:00',
    views: 890000,
    rating: 9.4,
    publishDate: '2025-02-01',
    tags: ['编程', 'Python', '教程', '入门'],
    slug: 'python-beginner-to-master',
  },
  {
    id: 'v009',
    title: '必看高分华语剧集：口碑炸裂推荐',
    description: '精选豆瓣8.5分以上的华语剧集，涵盖悬疑、都市、古装等多种类型，每一部都值得细细品味。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20series%20visual%20with%20warm%20atmospheric%20lighting%2C%20cinematic%20composition%2C%20elegant%20oriental%20aesthetic%2C%20soft%20golden%20hue%2C%20mysterious%20and%20emotional%20mood%2C%20professional%20film%20photography%20style&width=800&height=450&seq=video-cover-009&orientation=landscape',
    category: 'dianshiju',
    duration: '45:00',
    views: 2750000,
    rating: 9.5,
    publishDate: '2025-03-10',
    tags: ['剧集', '高分', '华语', '必看'],
    slug: 'top-rated-chinese-dramas',
  },
  {
    id: 'v010',
    title: '搞笑宠物合集：萌宠治愈你的每一天',
    description: '可爱猫咪、呆萌狗狗的搞笑日常合集，萌宠们的逗趣行为让你忘记烦恼，开心每一天。',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20pets%20playful%20moment%20in%20warm%20cozy%20home%20setting%2C%20golden%20sunlight%20through%20window%2C%20cats%20and%20dogs%20in%20natural%20poses%2C%20heartwarming%20atmosphere%2C%20soft%20cream%20and%20beige%20interior%2C%20happy%20and%20cheerful%20mood&width=800&height=450&seq=video-cover-010&orientation=landscape',
    category: 'duanshipin',
    duration: '0:32:15',
    views: 4100000,
    rating: 9.7,
    publishDate: '2025-03-15',
    tags: ['宠物', '搞笑', '治愈', '萌宠'],
    slug: 'funny-pets-compilation',
  },
  {
    id: 'v011',
    title: '热血动漫推荐：燃到停不下来',
    description: '精心挑选的燃系动漫作品推荐，从经典老番到当季新番，战斗、冒险、友情，总有一部点燃你的热血。',
    coverImage: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20action%20scene%20with%20warm%20dramatic%20lighting%2C%20energy%20effects%20in%20golden%20and%20orange%2C%20heroic%20character%20pose%2C%20epic%20atmosphere%2C%20modern%20anime%20art%20style%2C%20inspiring%20and%20powerful%20composition&width=800&height=450&seq=video-cover-011&orientation=landscape',
    category: 'dongman',
    duration: '2:10:00',
    views: 1650000,
    rating: 9.1,
    publishDate: '2025-02-28',
    tags: ['动漫', '热血', '推荐', '燃'],
    slug: 'hot-blooded-anime-recommendations',
  },
  {
    id: 'v012',
    title: '世界杯经典进球：足球史上的传奇时刻',
    description: '回顾世界杯历史上的经典进球，从马拉多纳到梅西，重温那些让全世界球迷疯狂的传奇瞬间。',
    coverImage: 'https://readdy.ai/api/search-image?query=Soccer%20stadium%20with%20dramatic%20golden%20hour%20lighting%2C%20celebration%20moment%20on%20green%20field%2C%20passionate%20fans%20in%20background%2C%20sports%20photography%20style%2C%20warm%20amber%20floodlights%2C%20epic%20and%20historic%20atmosphere&width=800&height=450&seq=video-cover-012&orientation=landscape',
    category: 'tiyu',
    duration: '1:45:00',
    views: 1980000,
    rating: 9.5,
    publishDate: '2025-03-05',
    tags: ['足球', '世界杯', '经典', '进球'],
    slug: 'world-cup-classic-goals',
  },
];